import { templateJoin } from 'bernie-graphql';

export const carDetailQuery = templateJoin`
        query CarDetail($context: ContextInput!, $carDetailContext: CarDetailContextInput!) {
    carDetail(context: $context, carDetailContext: $carDetailContext) {
        detailsNavTabs {
            navTabs {
                name
                analytics {
                ...detailAnalytics
                }
            }
        }
        reviewsSummary {
            title
            recommendedRate
            recommendedText
            topReviews
            dialogTrigger {
                ...detailActionableItem
            }
            dialogContent {
                description
                totalRatings
                disclaimerTitle
                disclaimerFullDescription
                disclaimerLink {
                    ...detailActionableItem
                }
                userFeedback {
                    ...userFeedback
                }
                reviewBreakdown {
                    heading
                    description
                    percentage
                    score
                }
                reviewsSeeMoreAction{
                    text
                    analytics {
                        ...detailAnalytics
                    }
                }
                reviews{
                    text
                    rentalDuration
                    author
                    classificationName
                    expandButton{
                        expandButton
                        collapseButton
                    }
                    submissionTime
                    themes{
                        icon{
                            id
                        }
                        label
                    }
                }
            }
        }
        deal {
            ...detailsMessagingCard
        }
        easeCancel {
            ...detailsMessagingCard
        }
        oneKeyInfo {
            ...detailBadge
        }
        oneKeyDetails {
            earnBanner {
                ...detailBadge
            }
            isOfferEligibleForBurn
            isOneKeyEnrolled
            analytics {
                ...detailAnalytics
            }
        }
        priceAlert {
            ...detailsMessagingCard
        }
        saleUnlocked {
            ...detailsMessagingCard
        }
        dropOffCharge {
            ...detailsMessagingCard
        }
        vehicle {
            image {
                ...detailImage
            }
            category
            categoryIcon {
                 ...detailIcon
            }
            description
            attributes {
                ...detailFeature
            }
            features {
                ...detailFeature
            }
            fuelInfo {
                ...detailFeature
            }
        }
        vendor {
            image {
                ...detailImage
            }
        }
        rentalLocations {
            title
            isLocationDataMerged
            pickUpLocation {
                ...carRentalLocationDetail
            }
            dropOffLocation {
                ...carRentalLocationDetail
            }
        }
        telesales {
            label
            phoneNumberLink {
                ...detailActionableItem
            }
        }
        promotions {
            icon {
                ...detailIcon
            }
            text
            additionalInfo
        }
        inclusionsDetail {
            title
            text
            inclusions {
                icon {
                    ...detailIcon
                }
                title
                summary
                description
                analytics {
                    ...detailAnalytics
                }
            }
        }
        availableAccessories {
            title
            description
            accessories {
                id
                name
                price
                pricePeriod
                selectionState
                analytics {
                    ...detailAnalytics
                }
                accessibility
                token
            }
        }
        importantInfo {
            title
            infos
            importantInfoItems {
                name
                subtext
                description
                analytics {
                    ...detailAnalytics
                }
            }
            rulesAndRestrictions {
                ...detailActionableItem
            }
        }
        actionableConfidenceMessages {
            ...detailCarPhrase
        }
        pairConfidenceMessages {
            ...detailCarPhrase
        }
        additionalBenefits {
            headingText
            benefits {
                ...detailCarPhrase
            }
        }
        priceDetails {
            title
            closeAction {
                ...detailAction
            }
            closeIcon {
                ...detailIcon
            }
            breakupSection {
                ...carBreakupComponent
            }
            summary {
                title
                total
                lineItems {
                    ...carBreakupLineItem
                }
                notIncludedInTotal {
                    ...carBreakupComponent
                }
            }
            priceDetailsButton {
                ...detailActionableItem
            }
        }
        priceSummary {
            lead {
                ...detailPriceInfo
            }
            total {
                ...detailPriceInfo
            }
            strikeThroughFirst
            loyaltyPointsOption {
                formattedPoints
                leadingCaption
                pointsFirst
            }
            reference {
                additionalInfo
                price {
                    ...detailMoney
                }
                qualifier
            }
            paymentInfo {
                icon {
                    ...detailIcon
                }
                text
                additionalPaymentInfo
            }
            discountBadge {
                ...detailBadge
            }
            priceAdditionalInfo
            accessibility
            floatingCTAPriceDetailsAnalytics {
                ...detailAnalytics
            }
            floatingCTAReserveButtonAnalytics {
                ...detailAnalytics
            }
        }
        reserveAction {
            ...detailActionableItem
        }
        shareFeedbackAction {
            text
            button {
                ...detailActionableItem
            }
        }
        loyaltyInfo {
            ...detailCarPhrase
        }
        variantsSummary {
            title
            variants {
                title
            }
        }
        carSearchLink {
            ...detailActionableItem
        }

        offerBadges {
            ...detailBadge
        }

        detailSummary {
            pageTitle
        }
        onlineCheckInInfo {
             title
             infos {
                ...detailCarPhrase
                    }
                }
        skipTheCounterInfo {
            title
            infos {
               ...detailCarPhrase
                   }
               }
        enhancedCleanlinessInfo {
            title
            infos {
                icon {
                    ...detailIcon
                }
                text
            }
            seeAllAction {
                ...detailActionableItem
            }
            vendorCleanlinessBadge {
                value
            }
            infoProviderText
            dialog {
                images {
                    value
                }
                title
                description
                content {
                    title {
                        icon {
                            ...detailIcon
                        }
                        text
                    }
                    infos
                }
                carouselButtonAllyStrings
            }
        }

        adsTargetingData {
            uuid
            siteId
            pageName
            origin
            dest
            locResolver
            dateStart
            dateEnd
            adProvider
        }

        rentalProtectionInfo {
            title
            rentalProtectionCard {
                ...rentalProtectionCard
            }
        }
        carOfferToken
    }
}

fragment rentalProtectionCard on RentalProtectionCard {
    title
    infos {
        icon {
            ...detailIcon
        }
        text
    }
    seeDetailsAction {
        ...detailActionableItem
    }
    priceSummary
    pricePeriod
    offerBadge {
        ...detailBadge
    }
    dialog {
        title
        description
        content {
            title
            description {
                icon {
                    ...detailIcon
                }
                text
            }
        }
    }
    selected
    clickAction {
        ...detailActionableItem
    }
}

fragment detailsMessagingCard on CarMessagingCard {
    title
    cardTitle {
        ...detailCarPhrase
    }
    description
    descriptions
    cardDescriptions {
        ...detailCarPhrase
    }
    mark
    image {
        description
        url
    }
    illustrationURL {
        value
    }
    icon {
        ...detailIcon
    }
    links {
        text
        url {
            value
            relativePath
        }
        icon {
            ...detailIcon
        }
        action {
            actionType
            analytics {
                linkName
                referrerId
            }
        }
    }
    dialog {
        title
        buttonText
        text
        type
        content {
            header {
                ...detailCarPhrase
            }
            body {
                title {
                    ...detailCarPhrase
                }
                body {
                    ...detailCarPhrase
                }
            }
            footer {
                ...detailCarPhrase
            }
        }
    }
    carRecommendations {
        ...detailCarRecommendations
    }
    analytics {
        ...detailAnalytics
    }
}

fragment detailCarRecommendations on CarRecommendations {
    __typename
    heading
    analytics {
        linkName
        referrerId
    }
    carRecommendationsCards {
        ...detailCarRecommendationCard
    }
}

fragment detailCarRecommendationCard on CarRecommendationCard {
    __typename
    icon {
        ...detailIcon
    }
    action {
        ...detailAction
    }

    ... on DateTimeRecommendationCard {
        icon {
            ...detailIcon
        }
        text {
            ...detailsRichText
        }
        subText {
            ...detailCarPhrase
        }
        action {
            ...detailAction
        }
    }

    ... on LocationRecommendationCard {
        icon {
            ...detailIcon
        }
        location {
            ...detailsRichText
        }
        city {
            ...detailCarPhrase
        }
        distanceText {
            ...detailCarPhrase
        }
        action {
            ...detailAction
        }
        pickUpLocation {
            ...detailCarSearchLocation
        }
    }

    ... on PartnerRecommendationCard {
        icon {
            ...detailIcon
        }
        action {
            ...detailAction
        }
        analytics {
            ...detailAnalytics
        }
        image {
            ...detailImage
        }
        title {
            ...detailCarPhrase
        }
        subText {
            ...detailCarPhrase
        }
        button {
                ...detailActionableItem
        }
        dialog {
            ... on PartnerRecommendationDialog {
                title {
                    ...detailCarPhrase
                }
                subTitle {
                    ...detailCarPhrase
                }
                text {
                    ...detailCarPhrase
                }
                button {
                ...detailActionableItem
                }
                closeDialog {
                    ...detailAction
                }
                content {
                    ... on PartnerRecommendationDialogContent {
                        title {
                            ...detailCarPhrase
                        }
                        body {
                            ...detailCarPhrase
                        }
                        confidenceMessage {
                            ...detailCarPhrase
                        }
                    }
                }
                image {
                    ...detailImage
                }
            }
        }
    }
     ... on LimitedResultMessageOnRecommendationCard {
        icon {
            ...detailIcon
        }
        action {
            ...detailAction
        }
        recommendationDialog {
            title
            buttonText
            text
            content {
                header {
                    ...detailCarPhrase
                }
                body {
                    title {
                        ...detailCarPhrase
                    }
                    body {
                        ...detailCarPhrase
                    }
                }
                footer {
                    ...detailCarPhrase
                }
            }
        }
    }
}

fragment detailCarSearchLocation on CarSearchLocation {
    shortName
    fullName
    regionId
}

fragment detailFeature on VehicleFeature {
    icon {
        ...detailIcon
    }
    text
    info {
        vehicleFeatureDialog {
            title
            text
            buttonText
        }
        carActionableItem {
            ...detailActionableItem
        }
    }
}

fragment detailPriceInfo on CarPriceInfo {
    price {
        ...detailMoney
    }
    accessibility
    qualifier
    formattedValue
}
fragment detailIcon on Icon {
    description
    id
    size
    withBackground
}
fragment detailImage on Image {
    description
    url
}
fragment detailMoney on Money {
    amount
    formatted
    currencyInfo {
        code
        name
        symbol
    }
}
fragment detailAnalytics on CarAnalytics {
    linkName
    referrerId
}
fragment detailAction on CarAction {
    actionType
    accessibility
    analytics {
        ...detailAnalytics
    }
}
fragment detailBadge on CarOfferBadge {
    icon {
        id
    }
    mark {
        id
        url {
            value
        }
    }
    text
    theme
}
fragment detailActionableItem on CarActionableItem {
    url {
        value
        relativePath
    }
    action {
        ...detailAction
    }
    text
    icon {
        ...detailIcon
    }
    tel {
        phoneNumber
        value
    }
}

fragment detailCarDialogConfidenceMessage on CarDialogConfidenceMessage {
    text
    icon {
        ...detailIcon
    }
    openDialogAction {
        ...detailAction
    }
    dialogContent {
        title
        text
        buttonText
    }
    iconMobileRender
}

fragment carVendorLocationInfo on CarVendorLocationInfo {
    icon {
        ...detailIcon
    }
    text
    locationSubInfo
}

fragment carRentalLocationDetail on CarRentalLocationDetail {
    title
    dateTime {
        ...carVendorLocationInfo
    }
    address {
        ...carVendorLocationInfo
    }
    hoursOfOperation {
        ...carVendorLocationInfo
    }
    instruction {
        ...carVendorLocationInfo
    }
}

fragment detailCarPhrase on CarPhrase {
    __typename
    ... on CarPhraseText {
        text
    }
    ... on CarPhrasePairText {
        richText {
            ...detailsRichText
        }
        richSubText {
            ...detailsRichText
        }
    }
    ... on CarPhraseIconText {
        text
        icon {
            ...detailIcon
        }
    }
    ... on CarActionableItem {
        ...detailActionableItem
    }
    ... on CarDialogConfidenceMessage {
        ...detailCarDialogConfidenceMessage
    }
    ... on CarsRichText {
        value
        style
        theme
    }
    ... on CarPhraseMark {
        text
        name
        url {
            value
            relativePath
        }
        description
    }
}

fragment detailsRichText on CarsRichText {
    value
    theme
    style
}

fragment carBreakupComponent on CarBreakupComponent {
    id
    title
    lineItems {
        ...carBreakupLineItem
    }
}

fragment carBreakupLineItem on CarBreakupLineItem {
    icon {
        ...detailIcon
    }
    mark {
        id
    }
    dialogContent {
        commonDialog {
            title
            text
            buttonText
        }
        breakupContent {
            ...carPriceBreakupDialogLineItem
        }
    }
    openDialogAction {
        ...detailAction
    }
    text
    accessibility
    subText
    value
    richValue {
        ...detailsRichText
    }
}

fragment carPriceBreakupDialogLineItem on CarBreakupLineItem {
    text
    value
    subText
}

fragment userFeedback on UserFeedback {
    userSurveyTitle
    options {
        inputHeading
        inputTextPlaceholder
        option {
            ...detailActionableItem
        }
    }
    submitConfirmation
    submit {
        ...detailActionableItem
    }
}

    `;

export const carDropOffSearchQuery = templateJoin`
        query CarDropOffSearch(
    $context: ContextInput!
    $primaryCarSearchCriteria: PrimaryCarCriteriaInput!
    $secondaryCriteria: ShoppingSearchCriteriaInput!
) {
    carDropOffSearch(
        context: $context
        primaryCarSearchCriteria: $primaryCarSearchCriteria
        secondaryCriteria: $secondaryCriteria
    ) {
        carDropOffTitle {
            url
            text
            icon {
                ...dropOffIcon
            }
            action {
                ...dropOffAction
            }
        }

        carDropOffOfferCardTitle

        carDropOffOfferCard {
            vehicle {
                image {
                    ...dropOffImage
                }
                category
                description
                attributes {
                    icon {
                        ...dropOffIcon
                    }
                    text
                }
                features {
                    ...dropOffFeature
                }
                fuelInfo {
                    ...dropOffFeature
                }
            }
            vendor {
                image {
                    ...dropOffImage
                }
            }
            tripLocations {
                pickUpLocation {
                    ...dropOffCarOfferVendorLocationInfo
                }
                dropOffLocation {
                    ...dropOffCarOfferVendorLocationInfo
                }
            }
            detailsContext {
                carOfferToken
                selectedAccessories
                rewardPointsSelection
                continuationContextualId
            }
            carPriceDetail {
                priceTitle
                priceSubInfo
            }
            selectButton {
                ... dropOffActionableItem
            }
            viewMap {
                ... dropOffActionableItem
            }
        }

        map {
            title
            text
            closeIcon {
                ...dropOffIcon
            }
            closeAction {
                ...dropOffAction
            }
            center {
                ...dropOffCoordinates
            }
            bounds {
                northeast {
                    ...dropOffCoordinates
                }
                southwest {
                    ...dropOffCoordinates
                }
            }
            zoomLevel
            markers {
                __typename
                type
                action {
                    ...dropOffAction
                }
                coordinates {
                    ...dropOffCoordinates
                }
                ... on CarItemCardMapMarker {
                    itemCard {
                        ... on CarMapSearchLocationCard {
                            title
                            text
                        }
                        ... on CarMapDropOffLocationCard {
                            vendorLocationId
                            vendorImage {
                                ...dropOffImage
                            }
                            address
                            distance
                            superlative
                            carPriceDetail {
                                priceTitle
                                priceSubInfo
                            }
                            selectButton {
                                ... dropOffActionableItem
                            }
                            detailsContext {
                                carOfferToken
                                selectedAccessories
                                rewardPointsSelection
                                continuationContextualId
                            }
                        }
                    }
                }
            }
        }

        shareFeedbackAction {
            text
            button {
                ...dropOffActionableItem
            }
        }
    }
}
fragment dropOffActionableItem on CarActionableItem {
    url {
        value
        relativePath
    }
    action {
        ... dropOffAction
    }
    text
}
fragment dropOffAnalytics on CarAnalytics {
    linkName
    referrerId
}
fragment dropOffAction on CarAction {
    actionType
    accessibility
    analytics {
        ...dropOffAnalytics
    }
}
fragment dropOffFeature on VehicleFeature {
    icon {
        ...dropOffIcon
    }
    text
    info {
        vehicleFeatureDialog {
            title
            text
            buttonText
        }
    }
}
fragment dropOffIcon on Icon {
    description
    id
    withBackground
    size
}
fragment dropOffImage on Image {
    description
    url
}
fragment dropOffCoordinates on Coordinates {
    latitude
    longitude
}
fragment dropOffCarOfferVendorLocationInfo on CarOfferVendorLocationInfo {
    icon {
        ...dropOffIcon
    }
    text
    locationSubInfo
}
    `;

export const carSearchV3Query = templateJoin`
        query CarSearchV3(
    $context: ContextInput!
    $primaryCarSearchCriteria: PrimaryCarCriteriaInput!
    $secondaryCriteria: ShoppingSearchCriteriaInput!
    $shoppingContext: ShoppingContextInput
) {
    carSearchOrRecommendations(
        context: $context
        primaryCarSearchCriteria: $primaryCarSearchCriteria
        secondaryCriteria: $secondaryCriteria
        shoppingContext: $shoppingContext
    ) {
        carSearchResults {
            shoppingContext {
                multiItem {
                    id
                }
            }
            carsShoppingContext {
                searchId
            }
            multiItemAnchorPriceToken
            multiItemPickUpDropOffMessage {
                message {
                    __typename
                    ... on CarPhraseText {
                        text
                    }
                }
            }
            multiItemPlayBackTitleBar {
                primary {
                    __typename
                    ... on CarPhraseText {
                        text
                    }
                }
                secondary {
                    longMessage {
                        __typename
                        ... on CarPhraseText {
                            text
                        }
                    }
                    shortMessage {
                        __typename
                        ... on CarPhraseText {
                            text
                        }
                    }
                    accessibilityMessage {
                        __typename
                        ... on CarPhraseText {
                            text
                        }
                    }
                }
            }
            listings {
                __typename
                ... on CarMessagingCard {
                    ...messagingCard
                }
                ... on CarOfferCard {
                    accessibilityString
                    offerBadges {
                        ...badge
                    }
                    vehicle {
                        image {
                            ...image
                        }
                        category
                        categoryIcon {
                           ...icon
                        }
                        description
                        attributes {
                            icon {
                                ...icon
                            }
                            text
                        }
                        features {
                            ...feature
                        }
                        fuelInfo {
                            ...feature
                        }
                    }
                    tripLocations {
                        pickUpLocation {
                            ...carOfferVendorLocationInfo
                        }
                        dropOffLocation {
                            ...carOfferVendorLocationInfo
                        }
                    }
                    vendor {
                        image {
                            ...image
                        }
                    }
                    detailsContext {
                        carOfferToken
                        selectedAccessories
                        rewardPointsSelection
                        continuationContextualId
                    }
                    priceBadges {
                        ...badge
                    }
                    actionableConfidenceMessages {
                        ...carPhrase
                    }
                    review {
                        rating
                        superlative
                        totalCount
                        richRatingText {
                         ...detailsRichText
                        }
                    }
                    priceSummary {
                        ...offerPriceSummary
                    }
                    shortList {
                        favorited
                        saveUrl
                        removeUrl
                    }
                    action {
                        ...carAction
                    }
                    reserveButtonText
                    infositeURL {
                        relativePath
                    }
                    offerHeading
                    multiItemPriceToken
                    additionalBenefits {
                        ...carPhrase
                    }
                    cancellationAndPaymentMessages {
                        ...carPhrase
                    }
                    clubbedPriceOptions {
                        dialogTrigger {
                            ...carActionableItem
                        }
                        dialogContent {
                            title
                            vendor {
                                image {
                                    ...image
                                }
                            }
                            vehicleCategory
                            vehicleDescription
                            optionsSummary {
                                ...carPhrase
                            }
                            clubbedPrices {
                                heading {
                                ...carPhrase
                                }
                                title {
                                ...carPhrase
                                }                           
                                offerBadges {
                                    ...badge
                                }
                                priceBadges {
                                    ...badge
                                }
                                priceSummary {
                                    ...offerPriceSummary
                                }
                                paymentMessages {
                                    ...carPhrase
                                }
                                additionalPaymentMessages {
                                ...carPhrase
                                }                                
                                cancellationMessages {
                                    ...carPhrase
                                }
                                additionalBenefits {
                                    ...carPhrase
                                }
                                reserveButtonAction {
                                    ...carAction
                                }
                                reserveButtonText
                                infositeURL {
                                    relativePath
                                }
                            }
                            commonAdditionalBenefits {
                                ...carPhrase
                            }
                            modalFooter
                        }
                    }
                    isFareComparisonTestEnabled
                    priceSummaryText

                    enhancedCleanlinessDialog {
                        images {
                            value
                        }
                        title
                        description
                        content {
                            title {
                                icon {
                                    ...icon
                                }
                                text
                            }
                            infos
                        }
                        carouselButtonAllyStrings
                    }
                    guaranteedAnalytics {
                        ...analytics
                    }
                    personalisedDeal {
                        ...carPhrase
                    }
                }
            }
            carRentalLocations {
                routeType
                pickUpLocation {
                    ...carSearchLocation
                }
                dropOffLocation {
                    ...carSearchLocation
                }
            }
            changeRentalLocation {
                link {
                    ... on CarActionableItem {
                        text
                    }
                }
                placeHolder {
                    ... on CarPhraseText {
                        text
                    }
                }
                primary {
                    ... on CarPhraseText {
                        text
                    }
                }
                secondary {
                    ... on CarPhraseText {
                        text
                    }
                }
            }
            summary {
                title
                dynamicTitle {
                    ...carPhrase
                }
                pageTitle
                includedFeeFooter {
                    title
                    description
                }
                carRecommendations {
                    ...carRecommendations
                }
            }
            filterNoMatchMessage {
                messagingCard {
                    ...messagingCard
                }
                allOffersTextSeparator
            }
            loadMoreAction {
                action {
                    ...carAction
                }
                icon {
                    ...icon
                }
                searchPagination {
                    size
                    startingIndex
                }
                text
            }
            loyaltyInfo {
                __typename
                ... on CarPhraseText {
                    text
                }
                ... on CarActionableItem {
                    ...carActionableItem
                }
                ... on CarPhraseMark {
                    text
                    name
                    url {
                        value
                        relativePath
                    }
                    description
                }
            }
            oneKeyInfo {
                isOneKeyEnrolled
            }
            sortAndFilter {
                title
                close {
                    ...icon
                }
                appliedFilterCount
                clearButtonTitle
                sections {
                    title
                    fields {
                        __typename
                        primary
                        secondary
                        ...SingleSelectionFragment
                        ...MultiSelectionFragment
                    }
                }
            }
            carAppliedSortAndFilters {
                appliedSortAndFilters {
                    id
                    text
                    value
                    crossIcon {
                        ...icon
                    }
                    analytics {
                        ...clientSideAnalytics
                    }
                }
            }

            shareFeedbackAction {
                text
                button {
                    ...carActionableItem
                }
            }

            adsTargetingData {
                uuid
                siteId
                pageName
                origin
                dest
                locResolver
                dateStart
                dateEnd
                adProvider
            }

            recommendedSortDisclaimer {
                ...carPhrase
            }

          recommendedSortExplanation {
              content {
                  ...carPhrase
              }
              feedback {
                  ...searchUserFeedback
              }
              closeAnalytics {
                  ...analytics
              }
          }

            makeModelDisclaimer {
                ...carPhrase
            }

            map {
                title
                text
                closeIcon {
                    ...icon
                }
                closeAction {
                    ...carAction
                }
                center {
                    ...coordinates
                }
                bounds {
                    northeast {
                        ...coordinates
                    }
                    southwest {
                        ...coordinates
                    }
                }
                zoomLevel
                markers {
                    __typename
                    type
                    action {
                        ...carAction
                    }
                    coordinates {
                        ...coordinates
                    }
                    ... on CarItemCardMapMarker {
                        itemCard {
                            ... on CarMapSearchLocationCard {
                                title
                                text
                            }
                            ... on CarMapPickupLocationCard {
                                vendorLocationId
                                vendorImage {
                                    ...image
                                }
                                address
                                distance
                                superlative
                                priceSummary {
                                    lead {
                                        ...priceInfo
                                    }
                                    total {
                                        ...priceInfo
                                    }
                                    strikeThroughFirst
                                    loyaltyPointsOption {
                                        formattedPoints
                                        leadingCaption
                                        pointsFirst
                                    }
                                    accessibility
                                }
                                seeCarsButtonText
                                action {
                                    ...carAction
                                }
                            }
                        }
                    }
                }
                mapButton {
                    url {
                        value
                    }
                    text
                    action {
                        ...carAction
                    }
                }
                filterTitle
                mapSearchThisAreaButton {
                    text
                    action {
                        ...carAction
                    }
                }
            }
        }
        carsErrorContent {
            icon {
                ...icon
            }
            heading
            subText
            analytics {
                linkName
                referrerId
            }
           errorEventName
           locationAnalytics {
                linkName
                referrerId
            }
        }
        carRecommendationContent {
            ... on CarRecommendations {
                ...carRecommendations
            }
        }
    }
}

fragment messagingCard on CarMessagingCard {
    title
    cardTitle {
        ...carPhrase
    }
    description
    descriptions
    cardDescriptions {
      ...carPhrase
    }
    mark
    image {
        description
        url
    }
    illustrationURL {
        value
    }
    icon {
        ...icon
    }
    links {
        text
        url {
            value
            relativePath
        }
        icon {
            ...icon
        }
        action {
            actionType
            analytics {
                linkName
                referrerId
            }
        }
    }
    dialog {
        title
        buttonText
        text
        content {
            header {
                ...carPhrase
            }
            body {
                title {
                    ...carPhrase
                }
                body {
                    ...carPhrase
                }
            }
            footer {
                ...carPhrase
            }
        }
        type
    }
    carRecommendations {
        ...carRecommendations
    }
    analytics {
        ...analytics
    }
}

fragment badge on CarOfferBadge {
    icon {
        ...icon
    }
    text
    theme
    mark {
        id
        url {
            value
        }
    }
}

fragment feature on VehicleFeature {
    icon {
        ...icon
    }
    text
    info {
        vehicleFeatureDialog {
            title
            text
            buttonText
        }
        carActionableItem {
            ...carActionableItem
        }
    }
}
fragment priceInfo on CarPriceInfo {
    price {
        ...money
    }
    accessibility
    qualifier
    formattedValue
}
fragment carActionableItem on CarActionableItem {
    url {
        value
        relativePath
    }
    action {
        ...carAction
    }
    text
    icon {
        ...icon
    }
}
fragment dialogContentCarPhrase on CarPhrase {
    __typename
    ... on CarPhraseText {
        text
    }
    ... on CarPhraseIconText {
        text
        icon {
            ...icon
        }
    }
    ... on CarsRichText {
        value
        style
    }
    ... on CarActionableItem {
        ...carActionableItem
    }
}
fragment carDialogConfidenceMessage on CarDialogConfidenceMessage {
    text
    icon {
        ...icon
    }
    openDialogAction {
        ...carAction
    }
    dialogContent {
        title
        text
        buttonText
        content {
            header {
                ...dialogContentCarPhrase
            }
            body {
                __typename
                title {
                    ...dialogContentCarPhrase
                }
                body {
                    ...dialogContentCarPhrase
                }
            }
            footer {
                ...dialogContentCarPhrase
            }
        }
        type
    }
    iconMobileRender
}
fragment carAction on CarAction {
    actionType
    accessibility
    analytics {
        ...analytics
    }
}
fragment icon on Icon {
    description
    id
    withBackground
    size
}
fragment image on Image {
    description
    url
}
fragment money on Money {
    amount
    formatted
    currencyInfo {
        code
        name
        symbol
    }
}
fragment analytics on CarAnalytics {
    linkName
    referrerId
}
fragment clientSideAnalytics on ClientSideAnalytics {
    linkName
    referrerId
}
fragment Expando on ShoppingSelectionExpando {
    expandLabel
    collapseLabel
    visible
    threshold
    minimalHeight
    analytics {
        ...clientSideAnalytics
    }
}
fragment MultiSelectionFragment on ShoppingMultiSelectionField {
    primary
    primaryIcon{
        ...icon
      }
    secondary
    options {
        ...FilterOption
    }
    expando {
        ...Expando
    }
}
fragment SingleSelectionFragment on ShoppingSelectionField {
    primary
    secondary
    options {
        ...FilterOption
    }
    expando {
        ...Expando
    }
}
fragment FilterOption on ShoppingSelectableFilterOption {
    id
    value
    primary
    secondary
    description
    accessibility
    selected
    disabled
    icon {
        ...icon
    }
    analytics {
        ...clientSideAnalytics
    }
}
fragment coordinates on Coordinates {
    latitude
    longitude
}

fragment carOfferVendorLocationInfo on CarOfferVendorLocationInfo {
    icon {
        ...icon
    }
    text
    locationSubInfo
}
fragment detailsRichText on CarsRichText {
    value
    theme
    style
}

fragment carRecommendations on CarRecommendations {
    __typename
    heading
    analytics {
        linkName
        referrerId
    }
    carRecommendationsCards {
        ...carRecommendationCard
    }
}

fragment carRecommendationCard on CarRecommendationCard {
    __typename
    icon {
        ...icon
    }
    action {
        ...carAction
    }

    ... on DateTimeRecommendationCard {
        icon {
            ...icon
        }
        text {
            ...detailsRichText
        }
        subText {
            ...carPhrase
        }
        action {
            ...carAction
        }
    }

    ... on LocationRecommendationCard {
        icon {
            ...icon
        }
        location {
            ...detailsRichText
        }
        city {
            ...carPhrase
        }
        distanceText {
            ...carPhrase
        }
        action {
            ...carAction
        }
        pickUpLocation {
            ...carSearchLocation
        }
    }

    ... on PartnerRecommendationCard {
        icon {
            ...icon
        }
        action {
            ...carAction
        }
        analytics {
            ...analytics
        }
        image {
            ...image
        }
        title {
            ...carPhrase
        }
        subText {
            ...carPhrase
        }
        button {
            ...carActionableItem
        }
        dialog {
            ... on PartnerRecommendationDialog {
                title {
                    ...carPhrase
                }
                subTitle {
                    ...carPhrase
                }
                text {
                    ...carPhrase
                }
                button {
                    ...carActionableItem
                }
                closeDialog {
                    ...carAction
                }
                content {
                    ... on PartnerRecommendationDialogContent {
                        title {
                            ...carPhrase
                        }
                        body {
                            ...carPhrase
                        }
                        confidenceMessage {
                            ...carPhrase
                        }
                    }
                }
                image {
                    ...image
                }
            }
        }
    }

    ... on AlternateRecommendationCard {
        icon {
            ...icon
        }
        action {
            ...carAction
        }
        analytics {
            ...analytics
        }
        image {
            ...image
        }
        title {
            ...carPhrase
        }
        subText {
            ...carPhrase
        }
        button {
            ...carActionableItem
        }
    }

     ... on LimitedResultMessageOnRecommendationCard {
        icon {
            ...icon
        }
        action {
            ...carAction
        }
        recommendationDialog {
            title
            buttonText
            text
            content {
                header {
                    ...carPhrase
                }
                body {
                    title {
                        ...carPhrase
                    }
                    body {
                        ...carPhrase
                    }
                }
                footer {
                    ...carPhrase
                }
            }
        }
    }
}
fragment carPhrase on CarPhrase {
    __typename
    ... on CarPhraseText {
        text
    }
    ... on CarPhrasePairText {
        richText {
            ...detailsRichText
        }
        richSubText {
            ...detailsRichText
        }
    }
    ... on CarPhraseIconText {
        text
        icon {
            ...icon
        }
    }
    ... on CarActionableItem {
        ...carActionableItem
    }
    ... on CarDialogConfidenceMessage {
        ...carDialogConfidenceMessage
    }
    ... on CarsRichText {
        value
        style
        theme
    }
    ... on CarPhraseMark {
        text
        name
        url {
            value
            relativePath
        }
        description
    }
    ... on CarOfferBadge {
        icon {
            ...icon
        }
        mark {
            id
            url {
                value
            }
        }
        text
        badgeTheme: theme
    }
}
fragment carSearchLocation on CarSearchLocation {
    shortName
    fullName
    regionId
}

fragment offerPriceSummary on CarPriceSummary {
    discountBadge {
        ...badge
    }
    lead {
        ...priceInfo
    }
    total {
        ...priceInfo
    }
    strikeThroughFirst
    loyaltyPointsOption {
        formattedPoints
        leadingCaption
        pointsFirst
    }
    accessibility
    reference {
        additionalInfo
        price {
            ...money
        }
        qualifier
    }
    paymentInfo {
        icon {
            ...icon
        }
        text
        additionalPaymentInfo
    }
    priceAdditionalInfo
}

fragment searchUserFeedback on UserFeedback {
    userSurveyTitle
    options {
        inputHeading
        inputTextPlaceholder
        option {
            ...carActionableItem
        }
    }
    submitConfirmation
    submit {
        ...carActionableItem
    }
}

    `;

